import { createSelector } from '@ngrx/store';

import { selectTrafficHistoryFeatureState, State } from '@ruby/modules/car-traffic/store';
import * as fromTrafficHistory from '@ruby/modules/car-traffic/store/reducers/car-traffic.reducer';
import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { selectCurrentCustomerSelected } from '@ruby/modules/customer-select/store/selectors/customers.selectors';

export const selectCarTrafficCoreState = createSelector(
  selectTrafficHistoryFeatureState,
  selectCurrentCustomerSelected,
  (state: State, customerSelected?: ICustomer) => ({
    state: state[fromTrafficHistory.featureKey],
    customerSelected
  })
);
